"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.format = exports.endOfYear = exports.endOfWeek = exports.endOfMonth = exports.endOfDay = exports.addMonths = exports.addDays = void 0;
exports.formatByString = formatByString;
exports.getEmpty = getEmpty;
exports.getMonth = void 0;
exports.getMonthArray = getMonthArray;
exports.getNextDay = getNextDay;
exports.getNextMonth = getNextMonth;
exports.getNextYear = getNextYear;
exports.getPreviousDay = getPreviousDay;
exports.getPreviousMonth = getPreviousMonth;
exports.getPreviousYear = getPreviousYear;
exports.getToday = getToday;
exports.getWeekArray = getWeekArray;
exports.getWeekdays = getWeekdays;
exports.getYearRange = getYearRange;
exports.inRange = inRange;
exports.isBefore = exports.isAfter = void 0;
exports.isEndOfMonth = isEndOfMonth;
exports.isEndOfWeek = isEndOfWeek;
exports.isSameYear = exports.isSameMonth = exports.isSameDay = exports.isEqual = void 0;
exports.isStartOfMonth = isStartOfMonth;
exports.isStartOfWeek = isStartOfWeek;
exports.subMonths = exports.subDays = exports.startOfYear = exports.startOfWeek = exports.startOfMonth = exports.startOfDay = exports.setYear = exports.setMonth = exports.min = exports.max = exports.isWithinInterval = void 0;
var _intlTs = require("@gogame/intl-ts");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } // import * as dateFNS from 'date-fns';
var WEEK_START_ON = 1;
var WEEK_END_ON = 0;
var weekOptions = {
  weekStartsOn: WEEK_START_ON
};
function isStartOfMonth(date) {
  return _intlTs.dateFNS.isSameDay(date, _intlTs.dateFNS.startOfMonth(date));
}
function isEndOfMonth(date) {
  return _intlTs.dateFNS.isSameDay(date, _intlTs.dateFNS.endOfMonth(date));
}
function isStartOfWeek(date) {
  return date.getDay() === WEEK_START_ON;
}
function isEndOfWeek(date) {
  return date.getDay() === WEEK_END_ON;
}
function getYearRange(start, end) {
  var startDate = _intlTs.dateFNS.startOfYear(start);
  var endDate = _intlTs.dateFNS.endOfYear(end);
  var years = [];
  var current = startDate;
  while (_intlTs.dateFNS.isBefore(current, endDate)) {
    years.push(current);
    current = _intlTs.dateFNS.addYears(current, 1);
  }
  return years;
}
function inRange(date) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [],
    _ref2 = _slicedToArray(_ref, 2),
    start = _ref2[0],
    end = _ref2[1];
  return (_intlTs.dateFNS.isBefore(date, end) || _intlTs.dateFNS.isEqual(date, end)) && (_intlTs.dateFNS.isAfter(date, start) || _intlTs.dateFNS.isEqual(date, start));
}
function formatByString(date, formatString) {
  return _intlTs.dateFNS.format(date, formatString);
}
function getWeekdays() {
  var now = new Date();
  return _intlTs.dateFNS.eachDayOfInterval({
    start: _intlTs.dateFNS.startOfWeek(now, weekOptions),
    end: _intlTs.dateFNS.endOfWeek(now, weekOptions)
  });
}
function getWeekArray(date) {
  var start = _intlTs.dateFNS.startOfWeek(_intlTs.dateFNS.startOfMonth(date), weekOptions);
  var end = _intlTs.dateFNS.endOfWeek(_intlTs.dateFNS.endOfMonth(date), weekOptions);
  var count = 0;
  var current = start;
  var nestedWeeks = [];
  while (_intlTs.dateFNS.isBefore(current, end)) {
    var weekNumber = Math.floor(count / 7);
    nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
    nestedWeeks[weekNumber].push(current);
    current = _intlTs.dateFNS.addDays(current, 1);
    count += 1;
  }
  return nestedWeeks;
}
function getNextMonth(date) {
  return _intlTs.dateFNS.addMonths(date, 1);
}
function getPreviousMonth(date) {
  return _intlTs.dateFNS.subMonths(date, 1);
}
function getNextYear(date) {
  return _intlTs.dateFNS.addYears(date, 1);
}
function getPreviousYear(date) {
  return _intlTs.dateFNS.subYears(date, 1);
}
function getNextDay(date) {
  return _intlTs.dateFNS.addDays(date, 1);
}
function getPreviousDay(date) {
  return _intlTs.dateFNS.subDays(date, 1);
}
function getMonthArray(date) {
  var firstMonth = _intlTs.dateFNS.startOfYear(date);
  var monthArray = [firstMonth];
  while (monthArray.length < 12) {
    var prevMonth = monthArray[monthArray.length - 1];
    monthArray.push(getNextMonth(prevMonth));
  }
  return monthArray;
}
function getToday() {
  return _intlTs.dateFNS.startOfToday();
}
function getEmpty(min, max) {
  var today = _intlTs.dateFNS.startOfToday();
  return _intlTs.dateFNS.isBefore(today, min) ? min : _intlTs.dateFNS.isAfter(today, max) ? max : today;
}
var min = exports.min = _intlTs.dateFNS.min;
var max = exports.max = _intlTs.dateFNS.max;
var isEqual = exports.isEqual = _intlTs.dateFNS.isEqual;
var isWithinInterval = exports.isWithinInterval = _intlTs.dateFNS.isWithinInterval;
var addDays = exports.addDays = _intlTs.dateFNS.addDays;
var subDays = exports.subDays = _intlTs.dateFNS.subDays;
var addMonths = exports.addMonths = _intlTs.dateFNS.addMonths;
var subMonths = exports.subMonths = _intlTs.dateFNS.subMonths;
var startOfMonth = exports.startOfMonth = _intlTs.dateFNS.startOfMonth;
var endOfMonth = exports.endOfMonth = _intlTs.dateFNS.endOfMonth;
var startOfDay = exports.startOfDay = _intlTs.dateFNS.startOfDay;
var endOfDay = exports.endOfDay = _intlTs.dateFNS.endOfDay;
var isSameMonth = exports.isSameMonth = _intlTs.dateFNS.isSameMonth;
var isSameDay = exports.isSameDay = _intlTs.dateFNS.isSameDay;
var startOfYear = exports.startOfYear = _intlTs.dateFNS.startOfYear;
var endOfYear = exports.endOfYear = _intlTs.dateFNS.endOfYear;
var isSameYear = exports.isSameYear = _intlTs.dateFNS.isSameYear;
var getMonth = exports.getMonth = _intlTs.dateFNS.getMonth;
var startOfWeek = exports.startOfWeek = _intlTs.dateFNS.startOfWeek;
var endOfWeek = exports.endOfWeek = _intlTs.dateFNS.endOfWeek;
var isAfter = exports.isAfter = _intlTs.dateFNS.isAfter;
var isBefore = exports.isBefore = _intlTs.dateFNS.isBefore;
var setYear = exports.setYear = _intlTs.dateFNS.setYear;
var setMonth = exports.setMonth = _intlTs.dateFNS.setMonth;
var format = exports.format = _intlTs.dateFNS.format;